import { AuthFeature } from '../../apis/generated';
import { useAccess } from './useAccess';

export function useIsTaskEditor(): boolean {
  const { access } = useAccess();

  return access?.available_features?.includes(AuthFeature.TASK_EDIT) ?? false;
}
